import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { adminEndpoints } from "@/features/admin/api/endpoints";
import type { ApprovalRequestDto } from "@/features/admin/api/dto";

/**
 * État d'une demande d'approbation (`GET /ApprovalRequests/{id}`) —
 * endpoint interrogé en direct par fee-engine, ledger et kyc avant
 * d'exécuter une action sensible (guide §6.8).
 */
export const useApprovalRequest = (
  approvalRequestId: string,
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.ADMIN_APPROVAL_REQUEST_DETAIL(approvalRequestId),
    queryFn: () =>
      fetchDataGet<ApprovalRequestDto>({
        url: adminEndpoints.approvalRequests.detail(approvalRequestId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(approvalRequestId),
  });
